import './CSS/ParagraphTextAboutMeStyle.css';
function ParagraphTextAboutMe(props) {

  const pStyle = {
    textAlign: "left"
  }
    return (
      <div>
       <p style={pStyle}>&nbsp;&nbsp;&nbsp;&nbsp;Hello! Welcome to my portfolio! My name is Tanya, and I was born in Kyiv, Ukraine. However, I now reside in Nova Scotia, Canada. After my graduation with a masters of psychology, I ventured into a career in human resources.This was until 2020 when I embarked a plane and began my new journey to Canada where I made the decision to switch gears and dive into a more creative and high tech field of web development. </p>
       <p style={pStyle}>&nbsp;&nbsp;&nbsp;&nbsp;My path into web development started with many hours of online learning and developing projects, of which you can check out below. </p>
       
       <p style={pStyle}>&nbsp;&nbsp;&nbsp;&nbsp;I really hope I can turn this hobby into a career, because it is what I truly enjoy, and I look forward to improving my skills every day. I've learned that every website is very much like a unique story, and I enjoy to code as much as I like to make designs.</p>  
      </div>  
    );
  }
  
  export default ParagraphTextAboutMe;
  